import { usePerformedSearchRequest } from 'clientState/providers/SearchRequestProvider';
import { buyPathMap } from 'clientState/providers/SearchRequestProvider/parsers';

export const DEAL_WEEKEND = 'deal.weekend';
export const DEAL_HOTTEST = 'deal.hottest';

const useGetBuyPathDeal = () => {
  const { buyPath } = usePerformedSearchRequest() || {};

  if (!buyPath) return null;

  if (buyPath === buyPathMap.WEEKEND_DEALS) return DEAL_WEEKEND;
  if (
    buyPath === buyPathMap.HOTTEST_DEALS ||
    buyPath === buyPathMap.INSPIRATIONAL_DEALS_PAGE
  )
    return DEAL_HOTTEST;

  return '';
};

export default useGetBuyPathDeal;
